// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.Trends = {
  trendsHash: null,
  error: null,
  trendsFetched: false,
};
